import { render, staticRenderFns } from "./AddIndustry.vue?vue&type=template&id=538da942&"
import script from "./AddIndustry.vue?vue&type=script&lang=js&"
export * from "./AddIndustry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports